import { ListProductSuggestionsDto } from "types/dto/ListProductSuggestionsDto";
import { ListDto, SuggestProductDto } from "../types/dto";
import { ApiService } from "./apiService";

export const suggestProduct = async (dto: SuggestProductDto) => {
  return await ApiService.post(`suggestions`, dto);
};

export const getProductSuggestions = async (dto: ListProductSuggestionsDto) => {
  const emptyCategoryParam = dto.emptyCategory ? `&emptyCategory=true` : '';
  const deletedParam = dto.deleted ? `&deleted=true` : '';
  return await ApiService.get(`suggestions?page=${dto.page}&size=${dto.size}&barcode=${dto.barcode}${emptyCategoryParam}${deletedParam}`);
}

export const getProductSuggestionById = async (suggestionId: string) => {
  return await ApiService.get(`suggestions/${suggestionId}`);
}

export const archiveProductSuggestion = async (suggestionId: string) => {
  return await ApiService.delete(`products/suggestions/${suggestionId}`);
}

export const deleteSuggestionImage = async ({
  suggestionId,
  mediaId,
}: {
  suggestionId: string;
  mediaId: string;
}) => {
  return await ApiService.delete(`suggestions/${suggestionId}/media/${mediaId}`);
};

export const deleteProductSuggestion = async (suggestionId: string) => {
  return await ApiService.delete(`suggestions/${suggestionId}`);
}

export const restoreProductSuggestion = async (suggestionId: string) => {
  return await ApiService.post(`suggestions/${suggestionId}/restore`, {});
}

export const permanentlyDeleteProductSuggestion = async (suggestionId: string) => {
  return await ApiService.delete(`suggestions/${suggestionId}/permanent`);
}